@layer design-system {
  .root {
    display: block;
    width: 100%;
    height: auto;
    min-height: 116px;
    overflow: visible;
  }

  .lane {
    --accent: var(--text-soft);
  }

  .laneRect {
    fill: color-mix(in srgb, var(--accent) 7%, rgba(var(--background-default-rgb), 0.68));
    stroke: color-mix(in srgb, var(--accent) 19%, transparent);
    stroke-width: 1;
  }

  .laneLabel {
    fill: color-mix(in srgb, var(--accent) 68%, var(--text-soft));
    font-size: 8px;
    font-weight: 900;
    letter-spacing: 0;
    pointer-events: none;
    text-transform: uppercase;
  }

  .arrowPath {
    fill: color-mix(in srgb, var(--text-soft) 72%, transparent);
  }

  .edgeGroup {
    pointer-events: none;

    &[data-dimmed] {
      opacity: 0.12;
    }

    &[data-selected] {
      .edge {
        stroke: var(--blue-11);
        stroke-width: 2.2;
      }
    }

    &[data-downstream] {
      .edge {
        stroke: var(--blue-9);
        stroke-width: 1.8;
      }
    }
  }

  .edge {
    fill: none;
    stroke: color-mix(in srgb, var(--text-soft) 46%, transparent);
    stroke-linecap: round;
    stroke-width: 1.6;
  }

  .edgeLabel {
    fill: var(--blue-11);
    font-size: 8px;
    font-weight: 850;
    paint-order: stroke;
    stroke: rgba(var(--background-default-rgb), 0.86);
    stroke-linejoin: round;
    stroke-width: 4px;
    text-anchor: middle;
  }

  .edgeHitArea {
    cursor: pointer;
    fill: none;
    pointer-events: stroke;
    stroke: transparent;
    stroke-width: 10;
  }

  .node {
    --accent: var(--text-soft);

    &[data-dimmed] {
      opacity: 0.22;
    }

    &[data-clickable] {
      cursor: pointer;
    }

    .nodeRect {
      fill: color-mix(in srgb, var(--accent) 12%, var(--background-soft));
      stroke: color-mix(in srgb, var(--accent) 48%, var(--background-soft));
      stroke-width: 1;
    }

    &[data-highlighted] {
      .nodeRect {
        fill: color-mix(in srgb, var(--accent) 22%, var(--background-soft));
        filter: drop-shadow(0 0 9px color-mix(in srgb, var(--accent) 42%, transparent));
        stroke: color-mix(in srgb, var(--accent) 86%, var(--text-default));
        stroke-width: 2;
      }

      .nodeLabel {
        fill: var(--text-default);
        font-weight: 900;
      }
    }
  }

  .nodeHalo {
    fill: color-mix(in srgb, var(--accent) 12%, transparent);
    stroke: color-mix(in srgb, var(--accent) 36%, transparent);
    stroke-width: 1;
  }

  .nodeDot {
    fill: var(--accent);
    filter: drop-shadow(0 0 4px color-mix(in srgb, var(--accent) 60%, transparent));
  }

  .nodeStripe {
    fill: var(--accent);
    opacity: 0.88;
  }

  .nodeSublabel {
    fill: var(--accent);
    font-size: 8px;
    font-weight: 900;
    pointer-events: none;
    text-transform: uppercase;
  }

  .nodeLabel {
    fill: var(--text-default);
    font-size: 9px;
    font-weight: 750;
    pointer-events: none;
  }

  .nodeDetail {
    fill: var(--text-soft);
    font-size: 8px;
    font-weight: 500;
    pointer-events: none;
  }

  .nodeHighlightPill {
    fill: color-mix(in srgb, var(--accent) 78%, var(--text-default));
    pointer-events: none;
  }

  .nodeHighlightLabel {
    fill: var(--text-inverse);
    font-size: 8px;
    font-weight: 900;
    pointer-events: none;
    text-anchor: middle;
    text-transform: uppercase;
  }

  .root[data-variant='lineage'] {
    min-height: 220px;

    .edge {
      stroke: color-mix(in srgb, var(--text-soft) 38%, transparent);
      stroke-width: 1.35;
    }

    .nodeRect {
      fill: color-mix(in srgb, var(--accent) 10%, rgba(var(--background-soft-rgb), 0.96));
      stroke: color-mix(in srgb, var(--accent) 42%, var(--background-default));
    }

    .nodeLabel {
      font-size: 9.5px;
    }

    .nodeDetail {
      font-size: 8.2px;
    }

    .nodeSublabel {
      font-size: 7.8px;
    }
  }
}
